import _export from "../internals/export";
import _globalThis2 from "../internals/global-this";
import _getBuiltIn from "../internals/get-built-in";
import _functionUncurryThis from "../internals/function-uncurry-this";
import _functionCall from "../internals/function-call";
import _fails from "../internals/fails";
import _toString from "../internals/to-string";
import _validateArgumentsLength from "../internals/validate-arguments-length";
import _base64Map from "../internals/base64-map";
var $ = _export;
var _globalThis = _globalThis2;
var getBuiltIn = _getBuiltIn;
var uncurryThis = _functionUncurryThis;
var call = _functionCall;
var fails = _fails;
var toString = _toString;
var validateArgumentsLength = _validateArgumentsLength;
var i2c = _base64Map.i2c;
var $btoa = getBuiltIn("btoa");
var charAt = uncurryThis("".charAt);
var charCodeAt = uncurryThis("".charCodeAt);
var BASIC = !!$btoa && !fails(function () {
  return $btoa("hi") !== "aGk=";
});
var NO_ARG_RECEIVING_CHECK = BASIC && !fails(function () {
  $btoa();
});
var WRONG_ARG_CONVERSION = BASIC && fails(function () {
  return $btoa(null) !== "bnVsbA==";
});
var WRONG_ARITY = BASIC && $btoa.length !== 1;

// `btoa` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-btoa
$({
  global: true,
  bind: true,
  enumerable: true,
  forced: !BASIC || NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY
}, {
  btoa: function btoa(data) {
    validateArgumentsLength(arguments.length, 1);
    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
    if (BASIC) return call($btoa, _globalThis, toString(data));
    var string = toString(data);
    var output = "";
    var position = 0;
    var map = i2c;
    var block, charCode;
    while (charAt(string, position) || (map = "=", position % 1)) {
      charCode = charCodeAt(string, position += 3 / 4);
      if (charCode > 255) {
        throw new (getBuiltIn("DOMException"))("The string contains characters outside of the Latin1 range", "InvalidCharacterError");
      }
      block = block << 8 | charCode;
      output += charAt(map, 63 & block >> 8 - position % 1 * 8);
    }
    return output;
  }
});
export default {};